import { render } from "./Branding.vue?vue&type=template&id=4ab843de&scoped=true&ts=true"
import script from "./Branding.vue?vue&type=script&lang=ts"
export * from "./Branding.vue?vue&type=script&lang=ts"

import "./branding.scss?vue&type=style&index=0&id=4ab843de&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab843de"]])

export default __exports__